import '../polyfills/closest-polyfill'
import bulmaEvents from './bulma-events'


document.addEventListener(
  'DOMContentLoaded',
  () => bulmaEvents.assignEvents(document),
)
